import { render, staticRenderFns } from "./LanguageLevels.vue?vue&type=template&id=c3521e9c&scoped=true&"
import script from "./LanguageLevels.vue?vue&type=script&lang=js&"
export * from "./LanguageLevels.vue?vue&type=script&lang=js&"
import style0 from "./LanguageLevels.vue?vue&type=style&index=0&id=c3521e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3521e9c",
  null
  
)

export default component.exports